require("core-js/modules/es6.array.map");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");
/**
 * arrayFilter
 * @description Fuction for filtering with array filter values
 */


function arrayFilter(rows, id, filterValue) {
  return rows.filter(function (row) {
    var rowValue = row.values[id];

    if (Array.isArray(filterValue) && filterValue.length > 0) {
      for (var _iterator = filterValue, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var value = _ref;

        if (rowValue.includes(value)) {
          return true;
        }
      }

      return false;
    }

    return true;
  });
}

module.exports.arrayFilter = arrayFilter;
/**
 * setArrayFilterValue
 * @description Function for setting the filter value of an array field
 */

function setArrayFilterValue(checkedOptions) {
  return checkedOptions.map(function (option) {
    return option.value;
  });
}

module.exports.setArrayFilterValue = setArrayFilterValue;